import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=340591e0&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340591e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340591e0')) {
      api.createRecord('340591e0', component.options)
    } else {
      api.reload('340591e0', component.options)
    }
    module.hot.accept("./order_detail.vue?vue&type=template&id=340591e0&scoped=true&", function () {
      api.rerender('340591e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/order_detail.vue"
export default component.exports